import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ResourcesService } from '../resources.service';
import {UserAccount} from '../../model/user-account';
import {UserAccountType} from '../../model/user-account-type';
import {User} from '../../model/user';
import {Intercom} from 'ng2-intercom/intercom';
import {StaticUtils} from '../../../utils/static-utils';

@Injectable()
export class
UserService {
  user: User;
  by: string;
  email: string;
  id: number;
  name: string;
  userAccountTypeDefault: UserAccountType;
  userAccountTypes: UserAccountType[];
  loaded = false;
  userAccount = new UserAccount();
  stripeApiKey_Public: string;
  stripeApiKey_Secret: string;
  accesses = {
    'manage': [1],
    'booking-comissions': [1]
  };

  constructor(private _resources: ResourcesService, private _intercom: Intercom) {  }

  destroy() {
    this.user = undefined;
    this.by = undefined;
    this.email = undefined;
    this.id = undefined;
    this.name = undefined;
    this.userAccountTypes = undefined;
    this.loaded = false;
  }

  async updateUser() {
    await this.getUserDetails().subscribe((user: User) => this.loadFromWSResponse(user));
  }

  loadFromWSResponse(res: User) {
    this.user = res;
    this.by = res['by'];
    this.email = res['email'];
    this.id = res['id'];
    this.userAccountTypeDefault = res['userAccountTypeDefault'];
    this.userAccountTypes = res['userAccountTypes'];

    this.stripeApiKey_Public = this.userAccountTypeDefault.agent.stripeApiKey_Public;
    this.stripeApiKey_Secret = this.userAccountTypeDefault.agent.stripeApiKey_Secret;

    this.userAccount.email = this.email;
    this.userAccount.id = this.id;
    this.userAccount.userAccountTypeDefault = this.userAccountTypeDefault;
    this.userAccount.userAccountTypes = this.userAccountTypes;

    this._intercom.update({
      app_id: 'zetpu2p7',
      user_id: this.user['id'],
      name: this.user['name'],
      brandName: this.user['brandName'],
      email: this.user['email'],
      platform: 'Agents',
      widget: {
        'activator': '#intercom'
      }
    });

    this.loaded = true;
  }

  getUserDetails(): Observable<User> {
    return this._resources.get('user/GetUserDetails');
  }

  userHasAccess(area: string): boolean {
    let result = false;
    const areaAccessList = this.accesses[area];
    if (areaAccessList) {
      for (const areaAccessLevel of areaAccessList) {
        if (areaAccessLevel === this.user.userAccountTypeDefault.accessType) {
          result = true;
          break;
        }
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/api/resources/user/user.service.ts